import buttoncss from "./../../css/button.module.css"
import Modal from "./../../elements/Modal";
import {Button} from "./../../elements/Button";
import Dropdown from "./../../elements/Dropdown";
import InputGroup from "./../../elements/InputGroup";
import { ReactComponent as CloseIcon } from "../../assets/icons/close.svg";


const ExportDataModal = ({ years,months, handleClose, setExportModal }) => {

  return (
    <Modal
      title="Export Logs"
      headerActions={
        <CloseIcon
          onClick={() => {
            handleClose();
            setExportModal(false);
          }}
          className="clickable"
        />
      }
      footerActions={
        <>
          <Button
            btnColor={buttoncss.secondary}
            onClick={() => {
              handleClose();
              setExportModal(false);
            }}
            label="Cancel"
          />
          <Button btnColor={buttoncss.primary} label="Export" />
        </>
      }
      onClose={() => console.log("Modal Closed")}
    >
      Lorem ipsum dolor sit amet consectetur. Sed cras quis ultricies dignissim
      suspendisse. Magna metus neque potenti nulla sodales vitae pharetra
      aliquet.
      <InputGroup
        inputs={[
          <>
            <Dropdown
              label="Select Year"
              options={years}
              onSelect={(value) => console.log("Selected:", value)}
              placeHolder={"Select Year"}
            />
          </>,
          <>
            <Dropdown
              label="Select Month"
              options={months}
              onSelect={(value) => console.log("Selected:", value)}
              placeHolder={"Select Month"}
            />
          </>,
        ]}
      />
    </Modal>
  );
};

export default ExportDataModal;
